import { SEARCHED_TEXT_CHANGED, SET_SEARCH_RESULTS } from "./constants";
import { ISearchedTextChangedAction, ISetSearchResultsAction, SearchResult } from "./types";

/**
 * Akce reprezentující změnu vyhledávaného textu.
 * @param searchedText Nová hodnota vyhledávaného textu.
 */
export const createSearchedTextChangedAction = (searchedText: string): ISearchedTextChangedAction => ({
    type: SEARCHED_TEXT_CHANGED,
    payload: {
        searchedText,
    },
});

/**
 * Akce pro nastavení výsledků vyhledávání do stavu, ze kterého se zobrazují.
 * @param searchResults Výsledky vyhledávání seřazené podle abecedy.
 */
export const createSetSearchResultsAction = (searchResults: ReadonlyArray<SearchResult>): ISetSearchResultsAction => ({
    type: SET_SEARCH_RESULTS,
    payload: {
        searchResults,
    },
});
